
import { createContext, useContext } from 'react';
import { IAbstractWorkItem, IAbstractWorkItemContext, IWorkItemOverview, IWorkItemTemplate } from 'models/work-items';
import { AbstractWorkItemProvider } from './abstracts';

export interface IWorkItemContext extends IAbstractWorkItemContext {
    workItem: IWorkItemOverview | null;
    template: IWorkItemTemplate | null;    
    btnContainer?: () => HTMLElement | null;
    updateWorkItemOverview: (overview?: IWorkItemOverview) => void;
};

const WorkItemContext = createContext<IWorkItemContext>({
    workItem: null,
    template: null,
    options: null,
    getOptionsForStatus: () => [],
    updateWorkItemOverview: (overview?: IAbstractWorkItem) => {}
});

const WorkItemConsumer = WorkItemContext.Consumer;

const useWorkItemContext = () => useContext(WorkItemContext);

type WorkItemProviderProps = {
    value: IWorkItemContext;
    children: React.ReactNode;
};

const WorkItemProvider = (props: WorkItemProviderProps) => {
    const { value, children } = props;
    return (
        <AbstractWorkItemProvider value={value}>
            <WorkItemContext.Provider value={value}>
                {children}
            </WorkItemContext.Provider>
        </AbstractWorkItemProvider>
    )
}

export default useWorkItemContext;
export { WorkItemProvider, WorkItemConsumer };